import { Performer } from '../core/performer'
import { HttpMethod } from '../core/types'

export class BroadcastMessage extends Performer<
  {
    urlParams: {
      id: number
    }
    payload: {
      message: string
    }
  },
  void
> {
  protected method = HttpMethod.POST
  protected url = '/webinars/{id}/broadcast-message'
}

export default new BroadcastMessage().perform
